import { ReactElement } from "react";

import {
  AccordionPanel,
  UnorderedList,
  UnorderedListItem,
} from "@justworkshr/milo-core";
import {
  GLOBAL_HIRING_GUIDES_LINK,
  INTERNATIONAL_CONTRACTORS_PRODUCT_HELP_LINK,
  JUSTWORKS_PEO_KEY_FEATURES_LINK,
} from "../../constants";

export const Faq = (): ReactElement => (
  <div>
    <AccordionPanel isOpen title="What is an employer of record (EOR)?">
      <p>
        An employer of record (EOR) company helps businesses onboard employees
        based in other countries, set up global payroll, and administer
        localized benefits without the need to set up a local entity. You're in
        control over the day-to-day work while we handle the logistical and
        administrative heavy lifting.
      </p>
      <br />
      <p>That includes:</p>
      <UnorderedList>
        <UnorderedListItem>Running payroll</UnorderedListItem>
        <UnorderedListItem>Managing tax withholdings</UnorderedListItem>
        <UnorderedListItem>
          Staying compliant with local labor laws
        </UnorderedListItem>
        <UnorderedListItem>
          Offering country-specific benefits
        </UnorderedListItem>
      </UnorderedList>
      <br />
      <p>
        Once you speak with our Account Development team and decide to move
        forward, you can onboard, pay, and manage your international team right
        from the same platform you use for your U.S. team.
      </p>
      <br />
      <p>
        You'll also get access to legal and compliance support, plus a team of
        global consultants to guide you as you grow across borders—without the
        cost or complexity of setting up your own legal entity.
      </p>
    </AccordionPanel>
    <AccordionPanel
      isOpen
      title="Can I switch to Justworks from another EOR provider?"
    >
      <p>
        Yes! Over 100 customers have already made the switch to Justworks to
        unify their teams on one platform, access faster support from in-house
        experts, and provide competitive benefits to their international
        employees.
      </p>
      <br />
      <p>
        Switching is easier than you think—connect with our team to see how
        seamless it can be.
      </p>
    </AccordionPanel>
    <AccordionPanel
      isOpen
      title="Where are Justworks' EOR services available? "
    >
      We have local entities in top talent markets across the globe in all
      continents (except Antarctica) including Canada, Mexico, India, Spain, the
      UK, and many more—and we're continuing to expand. For the most up-to-date
      list of supported countries and key insights about hiring internationally,{" "}
      <a href={GLOBAL_HIRING_GUIDES_LINK} target="_blank">
        check out our Global Hiring Guides.
      </a>
    </AccordionPanel>
    <AccordionPanel
      isOpen
      title="What is the difference between EOR and Justworks PEO?"
    >
      <p>
        <a href={JUSTWORKS_PEO_KEY_FEATURES_LINK} target="_blank">
          Justworks PEO
        </a>{" "}
        is designed for managing US-based employees. It provides a co-employment
        model that covers payroll, payroll tax reporting, benefits
        administration, HR support, and workers’ comp insurance—all in one
        intuitive platform. It’s ideal for small businesses growing their teams
        within the United States.
      </p>
      <br />
      <p>
        Justworks EOR is built for hiring full-time employees in other
        countries. Instead of setting up your own legal entity, we act as the
        legal employer in the country. We handle the complexities of local
        compliance, tax obligations, employment contracts, and benefits
        administration so you can easily hire and manage talent in international
        markets—all from the same Justworks platform.
      </p>
    </AccordionPanel>
    <AccordionPanel
      isOpen
      title="What is the difference between EOR and International Contractors?"
    >
      <p>
        EOR is the best fit when you want to hire someone as a full-time
        employee in another country. With EOR, Justworks becomes the legal
        employer on your behalf, managing payroll, taxes, compliance, and
        benefits for that employee—similar to how W-2 employment works in the
        U.S.
      </p>
      <br />
      <p>
        <a href={INTERNATIONAL_CONTRACTORS_PRODUCT_HELP_LINK} target="_blank">
          International Contractors
        </a>{" "}
        are ideal for more flexible or short-term work arrangements. These
        workers are not legally employed by your company or Justworks. While
        Justworks makes it easy to pay international contractors, you're
        responsible for managing the contractor relationship. Learn more about
        International contractors
      </p>
    </AccordionPanel>
  </div>
);
